<script setup lang="ts">
import { defineShortcuts } from '@nuxt/ui/composables';
import { useSettingsOverlay } from '#layers/global-settings/composables/use-settings-overlay';
import { useWorkspaceStore, WorkspaceLogo } from '#layers/workspace/public';

const { currentWorkspace } = useWorkspaceStore();
const { open, isOpen } = useSettingsOverlay();

defineShortcuts({
	meta_shift_o: () => open('organization/workspaces'),
});
</script>

<template>
	<DTooltip
		v-if="currentWorkspace"
		:disabled="isOpen"
		:text="$t('workspace.switcher.go_to_organization')"
		:content="{ side: 'right', sideOffset: 8 }"
		:kbds="['meta', 'shift', 'O']"
	>
		<button
			type="button"
			data-testid="workspace-badge"
			class="
				group relative block rounded-md
				focus-visible:ring-2 focus-visible:ring-(--ui-border-focused) focus-visible:outline-none
			"
			:aria-label="$t('workspace.switcher.go_to_organization')"
			@click="open('organization/workspaces')"
		>
			<WorkspaceLogo
				:workspace="currentWorkspace"
				size="sm"
				class="transition-opacity duration-150 ease-out group-hover:opacity-0 group-focus-visible:opacity-0"
			/>
			<div
				data-testid="workspace-badge-hover-logo"
				aria-hidden="true"
				class="
					absolute inset-0 flex items-center justify-center rounded-md bg-(--brand-color,var(--color-primary)) opacity-0
					transition-opacity duration-150 ease-out
					group-hover:opacity-100
					group-focus-visible:opacity-100
				"
				:style="currentWorkspace.primaryColor ? { '--brand-color': currentWorkspace.primaryColor } : undefined"
			>
				<DIcon name="lucide:maximize" class="size-5 text-white" />
			</div>
		</button>
	</DTooltip>
</template>
